import {
  useState,
  useEffect,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

import {
  Dropdown,
  CustomDropdownProps,
} from '@dynamika-shared/ui/Dropdown/Dropdown';
import { PossibleFilters } from '@restore/auditTrailsFilters/auditFilters.types';
import { twJoin } from '@dynamika-shared/utils/twMerge';

import { Filter, CloseIcon } from '@dynamika-shared/ui/icons';

type DropdownChipsTagProps = CustomDropdownProps & {
  name: ReactNode | string;
  keyFilter: PossibleFilters;
  closeTag: (name: PossibleFilters) => void;
  active: boolean;
  closeOnKeyDown: boolean;
  handleKeyDown: Dispatch<SetStateAction<boolean>>;
};

export const DropdownChipsTag = (props: DropdownChipsTagProps) => {
  const {
    name,
    keyFilter,
    closeTag,
    active,
    closeOnKeyDown,
    handleKeyDown,
    menuClassName,
    ...otherProps
  } = props;
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (closeOnKeyDown) {
      setVisible(false);
      handleKeyDown(false);
    }
  }, [closeOnKeyDown, handleKeyDown]);

  return active ? (
    <div className='sub-filter-container'>
      <div
        role='button'
        className='group/tag bg-waterLightHover50 hover:bg-waterLight flex h-[4rem] cursor-pointer items-center rounded-[32px] p-1'
        data-tesiid={`${name}`}
      >
        <Dropdown
          {...otherProps}
          trigger={['click']}
          open={visible}
          className='h-[4rem] p-1'
          onOpenChange={(_, { source }) => {
            if (source === 'trigger') setVisible(!visible);
          }}
          menuClassName={twJoin('max-h-[30rem]', menuClassName)}
        >
          <div className='flex items-center justify-center gap-1'>
            <Filter
              height={20}
              width={20}
              className='group-hover/tag:text-[#1D8EF2]'
            />
            <div className='text-1424 text-black group-hover/tag:text-[#1D8EF2] w-full'>
              {name}
            </div>
            <CloseIcon
              width={20}
              height={20}
              className='rounded-[4px] hover:bg-water hover:text-dodgerBlue'
              onClick={e => {
                e.stopPropagation();
                closeTag(keyFilter);
              }}
            />
          </div>
        </Dropdown>
      </div>
    </div>
  ) : null;
};
